<template>
	<div @click.self="$emit('close')" class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50">
		<div class="popup-bg text-[var(--popup-text-color)] rounded-lg p-8 w-10/12 md:w-3/6 lg:w-1/3 xl:w-1/4 relative">
			<button @click="$emit('close')" class="absolute top-4 right-4">
				<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkX : lightX" alt="Close Icon" class="w-3 h-3"/>
			</button>

			<h2 class="text-2xl font-archivomedium mb-4 text-center text-[var(--popup-text-color)]">
				Add Account
			</h2>

			<div class="flex flex-col space-y-4">
				<div>
					<label class="block mb-1 font-archivoregular text-sm text-[var(--text-color)]" >
						Account Name
					</label>
					<input :value="newAccountName" @input="$emit('update:newAccountName', $event.target.value)" type="text" :placeholder="`Account ${ accountCount + 1 }`" class="w-full px-4 py-2 rounded-lg bg-white bg-opacity-80 text-[#141414] font-archivolight focus:outline-none shadow-inner" />
				</div>
				<button @click="$emit('add-account')" class="my-4 w-full hover:bg-transparent bg-[var(--accent-color)] text-[var(--hover-text-color)] hover:text-[var(--accent-color)] border border-[var(--accent-color)] py-2 rounded-full transition duration-100 shadow-inner">
					Add Account
				</button>
			</div>
		</div>
	</div>
</template>

<script setup>
	import lightX from '../assets/X.png';
	import darkX from '../assets/XWhite.png';

	const props = defineProps({
		currentTheme: { type: String, required: true },
		newAccountName: { type: String, required: true },
		accountCount: { type: Number, required: true }
	});

	const emit = defineEmits([
		'close',
		'update:newAccountName',
		'add-account'
	]);
</script>

<style scoped>
	.popup-bg {
		background: var(--popup-bg-color);
	}
</style>
